import axios from 'axios';

export const getAtivosOptions = async () => {
  const response = await axios.get('/api/ativos/options');
  return response.data;
};
